import React from "react"
const Header = (props) => {
    return <h1>{props.headerText}</h1>
}
export default Header;